import { Component, OnInit, OnDestroy} from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { IOperation, OperationsListRequest } from '../../airport-interfaces';
import { TabViewModule } from 'primeng/primeng';
import { TabView } from 'primeng/primeng';
import { TabPanel } from 'primeng/primeng';

import { AirportService } from '../../airport.service';
import { IScenario, ScenarioService } from '../../../scenario-activities/scenario.service';

import { UserSession } from '../../../shared/user-session';
import { UserInfoService } from '../../../shared/user-info.service';

import { Button } from 'primeng/primeng';
import * as _ from 'lodash';

import { OperationsReforecastComponent } from './operations-reforecast.component';


@Component({
    template: require('./operations-reforecast-container.component.html'),
    styles: [require('../../../styles/faa_styles.css')],
    directives: [ROUTER_DIRECTIVES, Button, TabView, TabPanel, OperationsReforecastComponent]
})

export class OperationsReforecastContainerComponent implements OnInit, OnDestroy{
    pageTitle: string;
    errorMessage: string;
    private sub: any;    

    currentScenario: IScenario;
    allScenarios: IScenario[];

    isScenarioOwner: boolean = false;

    tableName: string;
    allOperations: IOperation[];
    locId: string;
    airportName: string;
    fieldName: string;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private _airportService: AirportService,
                private _scenarioService: ScenarioService, 
                private User: UserSession, 
                private _userInfoService: UserInfoService) {
    }


    ngOnInit(): void{
        this.sub = this.route.params.subscribe(
            params => {
                this.tableName = params['tableName'];
                this.locId = params['locId'];
                this.airportName = params['airportName'];
                this.fieldName = params['fieldName'];
                this._airportService.getOperations()
                    .subscribe(
                        operations => this.allOperations = operations,
                        error => this.errorMessage = <any>error);
            }
        );

        this._scenarioService.getScenarios(this.User.getSession()['id'])
            .subscribe(
                scenarios => this.allScenarios = scenarios,
                error => this.errorMessage = <any>error,
                () => {
                    this.setScenarioHeader(this.User.getSession().scenarioId);
                }
            );

        this._userInfoService.isScenarioOwner(this.User.getSession()['id'], this.User.getSession().scenarioId).subscribe(
            success => this.isScenarioOwner = success.isOwner,
            error => this.errorMessage = <any>error
        );
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    private setScenarioHeader(scenarioId: number):void {
        let foundScenarios:IScenario[] = this.allScenarios.filter(function(scenario){
            return scenario.id === scenarioId;
        });
        if(foundScenarios.length > 0){
            this.currentScenario = foundScenarios[0];
        }
    }

    onTabChange(event: any) {

        let request: OperationsListRequest = new OperationsListRequest();
        request.tableName = this.allOperations[event.index].tableName;
        request.scenarioId = this.User.getSession().scenarioId;
        request.locId = this.locId;
        request.isAdmin = this.User.getSession().isAdmin ? 1 : 0;

        this._airportService.getOperationsColumns(request)
                .subscribe(
                    columns => {
                        let column = columns.filter(function(column){ return column.calculated == 0; })[0];
                        
                        let params = {
                            locId: this.locId,
                            airportName: this.airportName,
                            fieldName: column.fieldName
                        }

                        this.router.navigate([`/operations-reforcast/${this.allOperations[event.index].tableName}`, params]);

                    },
                    error => this.errorMessage = <any>error);
    }

    backFacilityView(){
        this.router.navigate([`/airports/${this.locId}`]);
    }

    backDataSheet(){

        let params = {
            locId: this.locId,
            airportName: this.airportName
        }

        this.router.navigate([`/operations-list/${this.tableName}`, params]);
    }
}



/** WEBPACK FOOTER **
 ** ./app/airports/operations-lists/operations-reforecasts/operations-reforecast-container.component.ts
 **/